module.exports = __webpack_public_path__ + "img/haiwai.f50eccfb.png";